import { render, staticRenderFns } from "./PopupValuesEdit.vue?vue&type=template&id=4901d4f4&scoped=true&"
import script from "./PopupValuesEdit.vue?vue&type=script&lang=js&"
export * from "./PopupValuesEdit.vue?vue&type=script&lang=js&"
import style0 from "./PopupValuesEdit.vue?vue&type=style&index=0&id=4901d4f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4901d4f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VSpacer,VTextField})
